
<div>
  <div class="label">Shift handover comment</div>
  <div>{{ shiftOverview.comment || 'No comment was provided' }}</div>

  <div class="mt-2">
    <form v-on:submit.prevent="submitSearch">
      <div class="shift-hd-details">
        <div class="label mr-3">Board Items</div>

        <div>
          <checkbox-with-label
            :label="'Relevant items only'"
            v-model="onlyRelevantItems"
            @input="(value) => (isDirty = true)"
          ></checkbox-with-label>
        </div>

        <div class="search-items">
          <div class="input-group">
            <input v-debounce="submitSearch" type="text" class="form-control input-sm" placeholder="Search..." v-model="search" />
            <div class="input-group-append" @click="submitSearch">
              <i class="fa fa-search input-group-text"></i>
            </div>
          </div>
        </div>
      </div>
    </form>

    <table class="table table-striped fixed-header">
      <thead>
        <tr>
          <th scope="col">Category & Type</th>
          <th scope="col">Title & Description</th>
          <th scope="col">Labels</th>
          <th scope="col">Attachments</th>
          <th scope="col">Comments</th>
          <th scope="col">Subtasks</th>
          <th scope="col">Activity Date</th>
          <th scope="col">Status</th>
        </tr>
      </thead>
      <tbody>
        <shift-board-item-overview
          :item="item"
          v-for="(item, index) in items"
          :key="index"
          :action="navigateToBoardItem"
          :action-param="item.boardItemId"
          :display-relevant-badge="item.reportRelevant"
        ></shift-board-item-overview>
      </tbody>
    </table>

    <div v-if="!loading && (!items || !items.length)">
      <div class="label justify-content-center d-flex">No Board items found</div>
    </div>

    <div v-if="loading" class="d-flex align-items-center justify-content-center p-5">
      <loading-spinner></loading-spinner>
    </div>
  </div>

  <router-view></router-view>
</div>
